import { createContext } from "react"

const SectorsManagementContext = createContext();

export default SectorsManagementContext;